import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

import {findUser, login} from 'airship/clients/auth'
import {AuthResponse, FindUserArgs, LoginArgs} from 'airship/clients/auth/types'
import reportError from 'airship/modules/report-error'
import {isRequestError} from 'airship/modules/request2/utils/RequestError'

import {FindUserData} from './types'

const loginApi = createApi({
  baseQuery: fetchBaseQuery({baseUrl: ''}),
  reducerPath: 'loginApi',
  tagTypes: ['RedirectTo', 'DisplayLogin'],
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, LoginArgs>({
      queryFn: async (body) => {
        try {
          const data = await login(body)
          return {data}
        } catch (err) {
          if (isRequestError(err)) {
            if (err.response.body?.redirectTo) {
              return {data: err.response.body}
            }
            return {
              error: {
                status: err.statusCode,
                data: err.response.body?.error,
              },
            }
          }
          reportError(err)
          throw err
        }
      },
    }),
    findUser: builder.mutation<FindUserData, FindUserArgs>({
      queryFn: async (body) => {
        try {
          const data = await findUser(body)
          return {data: {...data, displayLogin: !data.redirectTo}}
        } catch (err) {
          if (isRequestError(err) && err.response.body.redirectTo) {
            return {data: err.response.body}
          }
          reportError(err)
          throw err
        }
      },
    }),
  }),
})

export default loginApi
